import { useState } from "react";

import { ProductAdvice } from "./ProductAdvice";
import ProductAdviceAdd from "./productAdd/ProductAdviceAdd";

type Props = {
  onClickBack?: () => void;
};

export const ProductAdviceDashboard = (props: Props) => {
  const { onClickBack } = props;
  const [screen, setScreen] = useState(0);
  const [arg, setArg] = useState<any>();

  const screens = [
    <ProductAdvice onClickBack={onClickBack} onNavigate={(s, arg) => {
      setArg(arg)
      setScreen(s)
    }} />,
    <ProductAdviceAdd onNavigate={(s) => s === -1? onClickBack?.() : setScreen(0)} arg={arg}  />
  ]

  
  return screens[screen];
};
